var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLsInProgress(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Level_Status_Icon",
    "data-name": "Level Status Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#e1e7e9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(2 2)",
    fill: "#c5ad7e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3407",
    "data-name": "Group 3407",
    transform: "translate(-1100.14 -405.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5749",
    "data-name": "Path 5749",
    d: "M1119.99,467.068a.494.494,0,0,0,.355.176h4.433a.5.5,0,0,0,.473-.555,3.672,3.672,0,0,0-1.683-2.839l-.062-.035-.053-.043a1.352,1.352,0,0,1-.445-.59.476.476,0,0,0-.893,0,1.355,1.355,0,0,1-.446.59l-.053.042-.061.032a3.679,3.679,0,0,0-1.683,2.843A.5.5,0,0,0,1119.99,467.068Z",
    transform: "translate(-8.422 -43.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5750",
    "data-name": "Path 5750",
    d: "M.473,1.048l6.663.13h0A.554.554,0,0,0,7.615.623.52.52,0,0,0,7.142.1L.479,0h0A.52.52,0,0,0,0,.521.52.52,0,0,0,.473,1.048Z",
    transform: "matrix(1, -0.017, 0.017, 1, 1110.323, 413.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5753",
    "data-name": "Path 5753",
    d: "M.473,1.048l6.663.13h0A.554.554,0,0,0,7.615.623.52.52,0,0,0,7.142.1L.479,0h0A.52.52,0,0,0,0,.521.52.52,0,0,0,.473,1.048Z",
    transform: "matrix(1, -0.017, 0.017, 1, 1110.323, 423.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5752",
    "data-name": "Path 5752",
    d: "M1121.377,428.96a3.747,3.747,0,0,0,.457.774,2.712,2.712,0,0,0,.877.758l.062.032.053.042a1.352,1.352,0,0,1,.445.59.476.476,0,0,0,.893,0,1.355,1.355,0,0,1,.445-.59l.053-.042.061-.032a1.767,1.767,0,0,0,.992-1.13.476.476,0,0,0-.264-.638,5.285,5.285,0,0,0-1.734-.29,3.791,3.791,0,0,1-1.767-.827.476.476,0,0,0-.768.427c.011.1.017.174.021.24A1.676,1.676,0,0,0,1121.377,428.96Z",
    transform: "translate(-9.577 -12.409)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLsInProgress);
export default __webpack_public_path__ + "static/media/icon_ls_in_progress.8371e61f96fa82bd87d614f8dd887421.svg";
export { ForwardRef as ReactComponent };